import { LocaleId, TranslationDictionaryMapping } from '@i18n';
import { FeatureRegisteredApplianceSummaryTranslationDictionary } from './feature-registered-appliance-summary-dictionary.interface';

export const translation: TranslationDictionaryMapping<FeatureRegisteredApplianceSummaryTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      REGISTERED_APPLIANCE_SUMMARY_TITLE:
        'Your {{ applianceName }} was successfully registered',
      REGISTERED_APPLIANCE_SUMMARY_MANUFACTURER_WARRANTY_LENGTH:
        'Manufacturer warranty length',
      REGISTERED_APPLIANCE_SUMMARY_MODEL_NUMBER: 'Model Number',
      REGISTERED_APPLIANCE_SUMMARY_PURCHASE_DATE: 'Purchase date',
      REGISTERED_APPLIANCE_SUMMARY_DISCLAIMER:
        'Covers parts and labour for manufacturing defects. Does not include accidental damage or cosmetic wear.',
    },
    [LocaleId.English_Ireland]: {
      REGISTERED_APPLIANCE_SUMMARY_TITLE:
        'Your {{ applianceName }} was successfully registered',
      REGISTERED_APPLIANCE_SUMMARY_MANUFACTURER_WARRANTY_LENGTH:
        'Manufacturer warranty length',
      REGISTERED_APPLIANCE_SUMMARY_MODEL_NUMBER: 'Model Number',
      REGISTERED_APPLIANCE_SUMMARY_PURCHASE_DATE: 'Purchase date',
      REGISTERED_APPLIANCE_SUMMARY_DISCLAIMER:
        'Covers parts and labour for manufacturing defects. Does not include accidental damage or cosmetic wear.',
    },
  };
